export type AccessLevel = "audit" | "user" | "maintainer" | "owner";
export type PermissionDetails = {
    controlOverrides: ControlOverride[],
};

export type ControlOverride = {
    controlUuid: string,
    maxTemp?: number,
}

export class PermissionRecord {
    id: number;
    uuid: string;
    siteId: number;
    userId: number;
    from: Date;
    until: Date;
    level: AccessLevel;
    data: string;
    created: Date;

    constructor(data:Partial<PermissionRecord>={}) {
        Object.assign(this, data);
    }
}